import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import ApiService from "../../../src/apiService";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from "../component/Table";
import Alert, { confirmedAlert } from "view/component/Alert";

export default class ModalRujukan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spesialis: true,
      dataSpesialis: [],
      dataSubSpesialis: [],
      dataSarana: [],
      dataRs: [],
      dataKhusus: [
        { kdKhusus: "IGD", name: "IGD" },
        { kdKhusus: "HDL", name: "HEMODIALISA" },
        { kdKhusus: "JIW", name: "JIWA" },
        { kdKhusus: "KLT", name: "KUSTA" },
        { kdKhusus: "PAR", name: "TB_MDR" },
        { kdKhusus: "KEM", name: "SARANA KEMOTERAPI" },
        { kdKhusus: "RAT", name: "SARANA RADIOTERAPI" },
        { kdKhusus: "HIV", name: "HIV-ODHA" },
        {
          kdKhusus: "THA",
          name: "THALASEMIA",
          kdSubSpesialis: [
            {
              kdSubSpesialis: "8",
              nmSubSpesialis: "HEMATOLOGI - ONKOLOGI MEDIK",
            },
            {
              kdSubSpesialis: "30",
              nmSubSpesialis: "ANAK HEMATOLOGI ONKOLOGI",
            },
          ],
        },
        {
          kdKhusus: "HEM",
          name: "HEMOFILI",
          kdSubSpesialis: [
            {
              kdSubSpesialis: "8",
              nmSubSpesialis: "HEMATOLOGI - ONKOLOGI MEDIK",
            },
            {
              kdSubSpesialis: "30",
              nmSubSpesialis: "ANAK HEMATOLOGI ONKOLOGI",
            },
          ],
        },
      ],
      sarana: false,
      subspesialis: null,
      sarana_list: 0,
      tglEstRujuk: moment(new Date()).format("YYYY-MM-DD"),
      kdppk: this.props.patient.provider
        ? this.props.patient.refferal.code_provider
        : "",
      spesialisKhusus: null,
      catatan: "",
      refTacc: [],
      refTaccInformation: [],
      tacc: -1,
      explanation: "",
      // isTacc: this.props.patient?.diagnoses[0]?.icd10?.non_specialist === "false" ? false : true,
      isTacc: this.props.patient?.diagnoses
        ? JSON.parse(
            this.props?.patient?.diagnoses?.filter((e) => e.log != true)[0]
              ?.icd10?.non_specialist
          ) == JSON.parse(false)
          ? false
          : true
        : false,
    };
    this.postRujukan = this.postRujukan.bind(this);
  }
  checkTacc = () => {
    let taccNotif = this.props.patient?.diagnoses
      ? JSON.parse(
          this.props?.patient?.diagnoses?.filter((e) => e.log != true)[0]?.icd10
            ?.non_specialist
        ) == JSON.parse(false)
        ? false
        : true
      : false;
    if (
      (taccNotif && this.state.tacc < 0) ||
      (taccNotif && this.state.explanation == "") ||
      (taccNotif && this.state.explanation == "pilih Alasan")
    ) {
      let hide = () => this.props.onHide();
      confirmedAlert(
        "Peringatan",
        "Diagnosa Merupakan Diagnosa TACC, Apakah Akan Tetap Dirujuk ? jika tetap akan dirujuk silahkan mengisi TACC dan ALASAN",
        function (confirmed) {
          if (confirmed) {
            // deletePatient(data);
          } else {
            hide();
          }
        }
      );
    }
  };
  componentDidMount() {
    this.checkTacc();
    this.getSpesialis();
    this.getSarana();
    this.getTacc();
  }
  getTaccByid = async (e) => {
    const res = await ApiService.get(
      "/registration/tacc/read/" + this.props.patient.id
    );
    if (res?.code === 200) {
      this.setState({
        tacc: res.data[0].type,
        explanation: res.data[0].information,
      });
    } else {
      console.log("TACC KOSONG");
    }
  };
  getTacc = async (e) => {
    const res = await ApiService.get("/management/tacc/read");
    if (res?.code === 200) {
      this.setState({ refTacc: res.data }, () => {
        this.getTaccByid();
      });
    } else {
      console.log("TACC KOSONG");
    }
  };

  getSpesialis = async (e) => {
    const url = "/spesialis";
    const res = await ApiService.post("/pcare", { url });
    if (res?.metaData?.code === 200) {
      this.setState({ dataSpesialis: res.response.list });
    } else {
      console.log("spesialis not load");
    }
  };
  getSubSpesialis = async (e) => {
    const url = "/spesialis/" + e.target.value + "/subspesialis";
    const res = await ApiService.post("/pcare", { url });
    if (res.metaData.code === 200) {
      this.setState({ dataSubSpesialis: res.response.list });
    } else {
      console.log("Subspesialis not load");
    }
  };

  getSarana = async (e) => {
    const url = "/spesialis/sarana";
    const res = await ApiService.post("/pcare", { url });
    if (res?.metaData?.code === 200) {
      this.setState({ dataSarana: res.response.list });
    } else {
      console.log("Subspesialis not load");
    }
  };
  onChangeSpesialisasi = (e) => {
    let spesialis = e.currentTarget.value === "true" ? true : false;
    this.setState({ spesialis });
  };
  onChangeSarana = (e) => {
    const target = e.target;
    const sarana = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ sarana });
  };
  HandleOnChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  HandleOnChangeSPKhusus = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value }, () => {
      if (value === "THA" || value === "HEM") {
        this.setState({
          dataSubSpesialis: this.state.dataKhusus.find(
            (e) => e.kdKhusus === value
          )?.kdSubSpesialis,
        });
      }
    });
  };

  getRS = async (e) => {
    this.checkTacc();
    let subspesialis = this.state.subspesialis;
    let sarana = this.state.sarana_list;
    let tglEstRujuk = moment(this.state.tglEstRujuk).format("DD-MM-YYYY");
    let spesialisKhusus = this.state.spesialisKhusus;
    let insurance_no = this.props.patient.insurance_no; //this.props.patient.insurance_no;
    let url = "";
    if (this.state.spesialis) {
      url =
        "/spesialis/rujuk/subspesialis/" +
        subspesialis +
        "/sarana/" +
        sarana +
        "/tglEstRujuk/" +
        tglEstRujuk;
    } else {
      if (spesialisKhusus === "THA" || spesialisKhusus === "HEM") {
        url =
          "/spesialis/rujuk/khusus/" +
          spesialisKhusus +
          "/subspesialis/" +
          this.state.subspesialis +
          "/noKartu/" +
          insurance_no +
          "/tglEstRujuk/" +
          tglEstRujuk;
      } else {
        url =
          "/spesialis/rujuk/khusus/" +
          spesialisKhusus +
          "/noKartu/" +
          insurance_no +
          "/tglEstRujuk/" +
          tglEstRujuk;
      }
    }
    const res = await ApiService.post("/pcare", { url });
    if (res.metaData.code == 200) {
      this.setState({ dataRs: res.response.list });
    } else {
      console.log("Subspesialis not load");
    }
  };

  postRujukan = async (e) => {
    if (this.state.isTacc) {
      if (
        this.state.explanation == "" ||
        this.state.explanation == "pilih Alasan"
      ) {
        Alert("error", "Lengkapi TACC dan Alasannya");
      } else {
        this.postTacc();
        let ref = "sub";
        this.state.spesialis ? (ref = "sub") : (ref = "special");
        let visit = {
          visit_id: this.props.patient.id,
          refferal_type: ref,
          refferal_date: this.state.tglEstRujuk,
          code_provider: this.state.kdppk,
          code: this.state.spesialisKhusus,
          sub_code: this.state.subspesialis,
          facility_code: this.state.sarana_list,
          note: this.state.catatan,
        };

        let res = await ApiService.put(`/registration/refferal`, visit);
        if (res.code === 200) {
          if (res.code === 200) {
            this.props.onHide();
          } else {
            console.log(visit);
          }
        }
      }
    } else {
      this.postTacc();
      let ref = "sub";
      this.state.spesialis ? (ref = "sub") : (ref = "special");
      let visit = {
        visit_id: this.props.patient.id,
        refferal_type: ref,
        refferal_date: this.state.tglEstRujuk,
        code_provider: this.state.kdppk,
        code: this.state.spesialisKhusus,
        sub_code: this.state.subspesialis,
        facility_code: this.state.sarana_list,
        note: this.state.catatan,
      };

      let res = await ApiService.put(`/registration/refferal`, visit);
      if (res.code === 200) {
        if (res.code === 200) {
          this.props.onHide();
        } else {
          console.log(visit);
        }
      }
    }
  };

  postTacc = async () => {
    let param = {
      visit_id: this.props.patient.id,
      type: this.state.tacc,
      information: this.state.explanation,
    };
    let res = await ApiService.post("/registration/tacc/create", param);
  };
  renderKhusus() {
    let dataKhusus = this.state.dataKhusus.map((data, key) => {
      return (
        <option key={key} value={data.kdKhusus}>
          {data.name}
        </option>
      );
    });

    let dataSubSpesialis = this.state.dataSubSpesialis.map((data, key) => {
      return (
        <option key={key} value={data.kdSubSpesialis}>
          {data.nmSubSpesialis}
        </option>
      );
    });
    return (
      <div>
        <div className="col-md-12">
          <div className="form-group row">
            <label className="col-md-5 col-form-label col-form-label-sm">
              Kategori
            </label>
            <div className="col-md-7">
              <div className="row">
                <select
                  className="form-control form-control-sm"
                  id="spesialisKhusus"
                  name="spesialisKhusus"
                  onChange={this.HandleOnChangeSPKhusus}
                >
                  <option key={2111} value={null}>
                    -
                  </option>
                  {dataKhusus}
                </select>
              </div>
            </div>
          </div>
          {this.state.spesialisKhusus === "HEM" ? (
            <div className="form-group row">
              <label className="col-md-5 col-form-label col-form-label-sm">
                Sub Spesialis
              </label>
              <div className="col-md-7">
                <div className="row">
                  <select
                    className="form-control form-control-sm"
                    id="subspesialis"
                    name="subspesialis"
                    onChange={this.HandleOnChange}
                  >
                    <option key={110000} value={0}>
                      -
                    </option>
                    {dataSubSpesialis}
                  </select>
                </div>
              </div>
            </div>
          ) : this.state.spesialisKhusus === "THA" ? (
            <div className="form-group row">
              <label className="col-md-5 col-form-label col-form-label-sm">
                Sub Spesialis
              </label>
              <div className="col-md-7">
                <div className="row">
                  <select
                    className="form-control form-control-sm"
                    id="subspesialis"
                    name="subspesialis"
                    onChange={this.HandleOnChange}
                    value={this.state.subspesialis}
                  >
                    <option key={110000} value={0}>
                      -
                    </option>
                    {dataSubSpesialis}
                  </select>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col-md-12">
          <div className="form-group row">
            <label className="col-md-5 col-form-label col-form-label-sm">
              Catatan
            </label>
            <div className="col-md-7">
              <div className="row">
                <textarea
                  className="form-control form-control-sm"
                  cols="100"
                  type="text"
                  id="example-text-input2"
                  name="catatan"
                  onChange={this.HandleOnChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderSarana = () => {
    let dataSarana = this.state.dataSarana.map((data, key) => {
      return (
        <option key={key} value={data.kdSarana}>
          {data.nmSarana}
        </option>
      );
    });
    return (
      <div>
        <select
          className="form-control form-control-sm"
          id="sarana_list"
          name="sarana_list"
          onChange={this.HandleOnChange}
        >
          <option key={1000} value={0}>
            -
          </option>
          {dataSarana}
        </select>
      </div>
    );
  };
  renderSpesialis = () => {
    let dataSpesialis = this.state.dataSpesialis.map((data, key) => {
      return (
        <option key={key} value={data.kdSpesialis}>
          {data.nmSpesialis}
        </option>
      );
    });
    let dataSubSpesialis = this.state.dataSubSpesialis.map((data, key) => {
      return (
        <option key={key} value={data.kdSubSpesialis}>
          {data.nmSubSpesialis}
        </option>
      );
    });
    let sarana = this.state.sarana ? this.renderSarana() : "";
    return (
      <div>
        <div className="form-group row">
          <div className="col-md-3">Spesialis</div>
          <div className="col-md-4">
            <select
              className="form-control form-control-sm"
              id="spesialis"
              name="spesialis"
              onChange={this.getSubSpesialis}
            >
              <option key={100000} value={0}>
                -
              </option>
              {dataSpesialis}
            </select>
          </div>
          <div className="col-md-5">
            <select
              className="form-control form-control-sm"
              id="subspesialis"
              name="subspesialis"
              onChange={this.HandleOnChange}
            >
              <option key={110000} value={0}>
                -
              </option>
              {dataSubSpesialis}
            </select>
          </div>
        </div>
        <div className="form-group row">
          <div className="col-md-4">
            <div className="custom-control custom-checkbox mb-3">
              <input
                className="custom-control-input"
                id="sarana"
                type="checkbox"
                onChange={this.onChangeSarana}
              />
              <label className="custom-control-label" htmlFor="sarana">
                Sarana
              </label>
            </div>
          </div>
          <div className="col-md-8">{sarana}</div>
        </div>
      </div>
    );
  };
  renderPilihanRS(e) {
    // console.log(e);
    return (
      <div>
        <div className="row">{e.nmppk}</div>
        <div className="row">
          <div>{e.alamatPpk}</div>
          <div>({e.kelas})</div>
        </div>
        <div className="row">{e.telpPpk}</div>
        <div className="row">jarak :{e.distance}</div>
      </div>
    );
  }
  renderRadioRS(e) {
    // console.log(e);
    return (
      <div>
        <div>
          <input
            type="radio"
            name="kdppk"
            value={e.kdppk}
            onChange={this.HandleOnChange}
          />
        </div>
      </div>
    );
  }
  renderTacc(e) {
    console.log(this.state.refTacc);
    console.log(this.props);

    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-5 col-form-label col-form-label-sm">
              Jenis Tacc
            </label>
            <div className="col-md-7">
              <div className="row">
                <select
                  className="form-control form-control-sm"
                  id="tacc"
                  name="tacc"
                  onChange={this.HandleOnChange}
                  value={this.state.tacc}
                >
                  {this.state.refTacc.map((d, k) => (
                    <option key={k} value={d.code}>
                      {d.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-5 col-form-label col-form-label-sm">
              Alasan TACC
            </label>
            <div className="col-md-7">
              <div className="row">
                <select
                  className="form-control form-control-sm"
                  id="explanation"
                  name="explanation"
                  onChange={this.HandleOnChange}
                  value={this.state.explanation}
                >
                  <option value="">pilih Alasan</option>

                  {this.state.tacc !== "3"
                    ? this.state.refTacc
                        .find((e) => e.code === this.state.tacc)
                        ?.explanations?.map((d, k) => (
                          <option key={k} value={d.name}>
                            {d.name}
                          </option>
                        ))
                    : this.props?.patient?.diagnoses?.map((d, k) => (
                        <option key={k} value={`${d.icd_code} - ${d.icd_name}`}>
                          {`${d.icd_code} - ${d.icd_name}`}
                        </option>
                      ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const { spesialis } = this.state;
    let spesialisasi =
      this.state.spesialis == true
        ? this.renderSpesialis()
        : this.renderKhusus();
    const tglEstRujuk = moment(this.state.tglEstRujuk).toDate();
    let Tacc = this.renderTacc();
    return (
      <Modal {...this.props} size="lg" aria-labelledby="modal-rujukan">
        <ModalHeader closeButton>
          <ModalTitle id="modal-rujukan">
            <div className="row">
              <div className="col-md-8"> RUJUKAN KE RS </div>
              <div className="col-md-4">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => {
                    this.props.onHide();
                    this.props.sisroute();
                  }}
                >
                  SISROUTE
                </button>
              </div>
            </div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          {this.state.isTacc ? Tacc : ""}

          <div className="row">
            <div className="col-md-4 ">
              <div className="custom-control custom-radio mb-3">
                <input
                  className="custom-control-input"
                  id="spesialis"
                  type="radio"
                  name="spesialis"
                  value="true"
                  onChange={this.onChangeSpesialisasi}
                  checked={spesialis === true}
                />
                <label className="custom-control-label" htmlFor="spesialis">
                  SPESIALIS
                </label>
              </div>
              <div className="custom-control custom-radio mb-3">
                <input
                  className="custom-control-input"
                  id="khusus"
                  type="radio"
                  name="spesialis"
                  value="false"
                  onChange={this.onChangeSpesialisasi}
                  checked={spesialis === false}
                />
                <label className="custom-control-label" htmlFor="khusus">
                  KONDISI KHUSUS
                </label>
              </div>
            </div>
            <div className="col-md-8 bg-success">
              <br /> {spesialisasi}
            </div>
            <div className="col-md-12" style={{ marginTop: "2%" }}>
              <div className="form-group row">
                <label className="col-md-4 col-form-label col-form-label-sm">
                  Tanggal estimasi rujuk
                </label>
                <div className="col-md-8">
                  <div className="row">
                    <DatePicker
                      className="form-control col-md-12"
                      selected={tglEstRujuk}
                      onChange={(date) =>
                        this.setState({
                          tglEstRujuk: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      value={this.tglEstRujuk}
                      dateFormat="dd-MM-yyyy"
                    />
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={this.getRS}
                    >
                      CARI RS
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Table
              headers={[
                "No",
                "PILIH",
                "Nama FASKES",
                "TOTAL RUJUKAN	KAPASITAS	( % )",
                "JADWAL",
              ]}
              data={this.state.dataRs}
              columnMapper={(data) => [
                this.renderRadioRS(data),
                this.renderPilihanRS(data),
                data.persentase,
                data.jadwal,
              ]}
              pagination={true}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="row">
            <button
              type="button"
              onClick={this.props.onHide}
              className="btn btn-danger"
            >
              tutup
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={this.postRujukan}
            >
              selesai
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}
